<template>
    <div v-if="hasError" class="oopsScreen">
        <img :src="require('@/assets/icons/frown.svg')" alt="Oops" class="oopsImg">
        <h1>
            Sorry, something went wrong
        </h1>
        <p>
            Please reload the page and try again
        </p>
    </div>
</template>

<script>
export default {
    name: "oops",
    data: () => ({
        hasError: false
    }),
    methods: {
        showOops: function() {
            var globv = this;
            globv.hasError = true;
        },
        reset: function() {
            var globv = this;
            globv.hasError = false;
        }
    }
}
</script>

<style lang="scss">
.oopsScreen {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: lightgray;
    background-color: var(--dashBackgroundColor);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 11;
    text-align: center;
    font-size: 1.5rem;
}

.oopsImg {
    height: 120px;
    padding: 5px;
    filter: opacity(0.6);
}
</style>